import * as React from "react";
import { useEffect, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  setIsDrawInProgress,
  setShouldSpinWheel,
} from "../../store/picks/tabs-slice";
import {
  clearAllUserPicks,
  setLastPickHistory,
  ticketPayout,
} from "../../store/picks/userPick-slice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setCarouselNumber } from "../../store/picks/carousel-slice";
import { setWinningNumber } from "../../store/wheel-slice";
import store from "../../store/store";
import { clearWin } from "../../store/config-slice";

import AleaControlShell from "../../communication/AleaControlShell";

import ModalMessage from "../Common/ModalMessage/ModalMessage";

const ShellWrapper: React.FC = () => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const isDrawInProgress = useAppSelector(
    (state) => state.tab.isDrawInProgress
  );
  const [infoModalMessage, setInfoModalMessage] = useState("");
  const [modalClassName, setModalClassName] = useState("");

  const changeLanguageEvent = useCallback(
    (lang: string): void => {
      let langI18n = "en";

      if (lang === "sr_sr" || lang === "sr_rs" || lang === "sr") {
        langI18n = "srsr";
      } else if (
        lang === "sr_me" ||
        lang === "hr" ||
        lang === "hr_hr" ||
        lang === "sr_bs" ||
        lang === "sr_ba" ||
        lang === "bs" ||
        lang === "ba"
      ) {
        langI18n = "srba";
      } else if (lang === "en_en") {
        langI18n = "en";
      } else if (lang === "sq_al") {
        langI18n = "sq";
      } else if (lang === "es_es") {
        langI18n = "es";
      } else if (lang === "de_de") {
        langI18n = "de";
      }

      i18n.changeLanguage(langI18n);
    },
    [i18n]
  );

  const publishPresentationEvent = useCallback(
    (data: any) => {
      const parsedData = JSON.parse(data);

      dispatch(setWinningNumber(parsedData.drawnNumber));
      dispatch(setCarouselNumber(parsedData.carouselMultiplier));
      dispatch(setShouldSpinWheel(true));
    },
    [dispatch]
  );

  useEffect(() => {
    AleaControlShell.setChangeLanguageEvent(changeLanguageEvent);
    AleaControlShell.setPublishPresentationEvent(publishPresentationEvent);
  }, [changeLanguageEvent, publishPresentationEvent]);

  useEffect(() => {
    let landbaseDrawTimeout: NodeJS.Timeout;

    if (isDrawInProgress) {
      setInfoModalMessage("message.drawInProgress");

      landbaseDrawTimeout = setTimeout(() => {
        AleaControlShell.refreshBalance();

        if (store.getState().config.winAmmount > 0) {
          setInfoModalMessage("message.congratsWin");
          setModalClassName("fade_modal");
        } else {
          setInfoModalMessage("message.betterLuck");
          setModalClassName("lost fade_modal");
        }

        dispatch(setIsDrawInProgress(false));
        dispatch(ticketPayout(store.getState().picks.ticketIdentification));
      }, 15000);
    }

    return () => clearTimeout(landbaseDrawTimeout);
  }, [isDrawInProgress, dispatch]);

  return (
    <>
      {isDrawInProgress && infoModalMessage !== "" && (
        <ModalMessage message={infoModalMessage} />
      )}

      {!isDrawInProgress && infoModalMessage !== "" && (
        <ModalMessage
          className={modalClassName}
          message={infoModalMessage}
          onApprove={() => {
            dispatch(setLastPickHistory());
            dispatch(clearAllUserPicks());
            setInfoModalMessage("");
            dispatch(clearWin());
          }}
          winAmount={store.getState().config.winAmmount}
        />
      )}
    </>
  );
};

export default ShellWrapper;
